import { api } from "../configs/axiosConfigs";

const pick = (obj, ...keys) => {
  if (!obj) return undefined;
  for (const key of keys) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  return undefined;
};

export const verifyContractorMasterByCode = async (verificationCode) => {
  const code = String(verificationCode || "").trim();
  const response = await api.request({
    url: `api/sln/contractor-master-contracts/verify/${encodeURIComponent(code)}`,
    method: "GET",
  });
  const raw = response?.data?.data ?? response?.data?.Data ?? response?.data ?? {};
  return {
    isValid: Boolean(pick(raw, "isValid", "IsValid")),
    contractType: pick(raw, "contractType", "ContractType") || "CONTRACTOR_MASTER",
    contractNumber: pick(raw, "contractNumber", "ContractNumber") || "",
    versionNumber: pick(raw, "versionNumber", "VersionNumber"),
    status: pick(raw, "status", "Status") || "",
    statusTitle: pick(raw, "statusTitle", "StatusTitle") || "",
    signatureStatus: pick(raw, "signatureStatus", "SignatureStatus") || "",
    lifecycleStatus: pick(raw, "lifecycleStatus", "LifecycleStatus") || "",
    solarentPartyName: pick(raw, "solarentPartyName", "SolarentPartyName") || "",
    contractorPartyDisplayName:
      pick(raw, "contractorPartyDisplayName", "ContractorPartyDisplayName") || "",
    pdfSha256: pick(raw, "pdfSha256", "PdfSha256") || "",
    integrityStatus: pick(raw, "integrityStatus", "IntegrityStatus") || "",
    activatedAt: pick(raw, "activatedAt", "ActivatedAt") || null,
    message: pick(raw, "message", "Message") || response?.data?.message || "",
  };
};
